/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Events_Search_CountInputs */

const en_events_search_count = /** @type {(inputs: Events_Search_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Events: ${i?.count}`)
};

const pl_events_search_count = /** @type {(inputs: Events_Search_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wydarzenia: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Events: {count}" |
*
* @param {Events_Search_CountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const events_search_count = /** @type {((inputs: Events_Search_CountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Search_CountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_events_search_count(inputs)
	return en_events_search_count(inputs)
});